export default function CourseTerms() {
    return (
        <>
            <section id="guitar-course-details-section">
                <div className="guitar-course-details-container">
                    <div className="guitar-course-details-content">
                        <div className="course-detail-item">
                            <h3 className="course-detail-title">TRAINING INVOLVES</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Raga practice, alankars, and taans.</li>
                                <li>Voice training and alap improvisation.</li>
                                <li>Understanding and mastering rhythm cycles (taal).</li>
                                <li>Bandish and khayal singing practice.</li>
                                <li>Repertoire building with classical depth.</li>
                            </ul>
                        </div>

                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Who is it For</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Beginners aiming for strong vocal foundation.</li>
                                <li>Intermediate students preparing for exams.</li>
                                <li>Advanced learners pursuing classical performance careers.</li>
                                <li>Students passionate about Indian traditional music.</li>
                            </ul>
                        </div>

                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Learning Outcomes</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Confident raga performance with improvisation.</li>
                                <li>Enhanced voice range and flexibility.</li>
                                <li>Mastery over taal-raga system.</li>
                                <li>Readiness for Bhatkhande, Banasthali, and university-level certifications.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 